import {
    PlusCircle, Edit2, Trash, Lock, Mail, Bookmark, X, Maximize, Minimize, Info, Check, Copy,
    Plus, Minus, Paperclip, User, Search, ChevronDown, ChevronUp, ArrowDown, ArrowUp, ArrowRight,
    RefreshCw, CheckCircle, PauseCircle, XCircle, Eye, EyeOff, AlertCircle, AlertTriangle,
    Slash, WifiOff, Menu, Play, PlayCircle, DownloadCloud, Video, FileText, MoreHorizontal,
    PhoneMissed, PhoneCall, BookOpen, Shield, Users, Archive, UserX,
    CheckSquare, Filter, Calendar, ChevronLeft, ChevronRight, CornerUpLeft, MoreVertical, Clock,
    LogOut, Download, ExternalLink, CreditCard, MinusCircle, HelpCircle, MapPin, List, CornerLeftUp
} from 'react-feather';

import {ReactComponent as Activities} from './assets/activities.svg';
import {ReactComponent as AddCreditCard} from './assets/add-credit-card.svg';
import {ReactComponent as AgentAfterHoursIcon} from './assets/agent-after-hours.svg';
import {ReactComponent as AgentCallingIcon} from './assets/agent-calling.svg';
import {ReactComponent as AgentParticipantIcon} from './assets/agent-participant.svg';
import {ReactComponent as AgentUnavailableIcon} from './assets/agent-unavailable.svg';
import {ReactComponent as AgentIcon} from './assets/agent.svg';
import {ReactComponent as AmericanExpress} from './assets/american-express.svg';
import {ReactComponent as AudioVideoIcon} from './assets/audio-video.svg';
import {ReactComponent as AudioIcon} from './assets/audio.svg';
import {ReactComponent as BackgroundBlurIcon} from './assets/background-blur.svg';
import {ReactComponent as BarChart} from './assets/bar-chart.svg';
import {ReactComponent as BellOffIcon} from './assets/bell-off.svg';
import {ReactComponent as BellOnIcon} from './assets/bell-on.svg';
import {ReactComponent as BrowserChromeIcon} from './assets/browser-chrome.svg';
import {ReactComponent as BrowserEdgeIcon} from './assets/browser-edge.svg';
import {ReactComponent as BrowserFirefoxIcon} from './assets/browser-firefox.svg';
import {ReactComponent as BrowserIeIcon} from './assets/browser-ie.svg';
import {ReactComponent as BrowserOperaIcon} from './assets/browser-opera.svg';
import {ReactComponent as BrowserSafariIcon} from './assets/browser-safari.svg';
import {ReactComponent as BrowserSamsungIcon} from './assets/browser-samsung.svg';
import {ReactComponent as BrowserUnsupportedIcon} from './assets/browser-unsupported.svg';
import {ReactComponent as CalendarRemove} from './assets/calendar-remove.svg';
import {ReactComponent as CameraIcon} from './assets/camera.svg';
import {ReactComponent as ChatGpt} from './assets/chat-gpt.svg';
import {ReactComponent as ChatHighlightedUnreadIcon} from './assets/chat-highlighted-unread.svg';
import {ReactComponent as ChatHighlightedIcon} from './assets/chat-highlighted.svg';
import {ReactComponent as ChatUnreadIcon} from './assets/chat-unread.svg';
import {ReactComponent as ChatIcon} from './assets/chat.svg';
import {ReactComponent as Chat2Icon} from './assets/chat2.svg';
import {ReactComponent as Chatbot} from './assets/chatbot.svg';
import {ReactComponent as ChecklistIcon} from './assets/checklist.svg';
import {ReactComponent as Claude} from './assets/claude.svg';
import {ReactComponent as ClientParticipantIcon} from './assets/client-participant.svg';
import {ReactComponent as CoBrowsingIcon} from './assets/co-browsing.svg';
import {ReactComponent as CompletedIcon} from './assets/completed.svg';
import {ReactComponent as CreateLinkIcon} from './assets/create-link.svg';
import {ReactComponent as CrossLineIcon} from './assets/cross-line.svg';
import {ReactComponent as DevicePhoneIcon} from './assets/device-phone.svg';
import {ReactComponent as DeviceSipIcon} from './assets/device-sip.svg';
import {ReactComponent as Discover} from './assets/discover.svg';
import {ReactComponent as Duplicate} from './assets/duplicate.svg';
import {ReactComponent as EmailIcon} from './assets/email.svg';
import {ReactComponent as FaceDissatisfied} from './assets/face-dissatisfied.svg';
import {ReactComponent as FaceNeutral} from './assets/face-neutral.svg';
import {ReactComponent as FaceSatisfied} from './assets/face-satisfied.svg';
import {ReactComponent as FaceVeryDissatisfied} from './assets/face-very-dissatisfied.svg';
import {ReactComponent as FaceVerySatisfied} from './assets/face-very-satisfied.svg';
import {ReactComponent as Folders} from './assets/folders.svg';
import {ReactComponent as GridIcon} from './assets/grid.svg';
import {ReactComponent as HourglassIcon} from './assets/hourglass.svg';
import {ReactComponent as IdIcon} from './assets/id.svg';
import {ReactComponent as Jcb} from './assets/jcb.svg';
import {ReactComponent as LockClosedIcon} from './assets/lock-closed.svg';
import {ReactComponent as LockOpenedIcon} from './assets/lock-opened.svg';
import {ReactComponent as LogoCrossedIcon} from './assets/logo-crossed.svg';
import {ReactComponent as LogoIcon} from './assets/logo.svg';
import {ReactComponent as MasterCard} from './assets/mastercard.svg';
import {ReactComponent as MediaSettings} from './assets/media-settings.svg';
import {ReactComponent as MicrophoneOffIcon} from './assets/microphone-off.svg';
import {ReactComponent as MicrophoneOnIcon} from './assets/microphone-on.svg';
import {ReactComponent as MicrophoneIcon} from './assets/microphone.svg';
import {ReactComponent as MultiscreenOffIcon} from './assets/multiscreen-off.svg';
import {ReactComponent as MultiscreenOnIcon} from './assets/multiscreen-on.svg';
import {ReactComponent as OsAndroidIcon} from './assets/os-android.svg';
import {ReactComponent as OsLinuxIcon} from './assets/os-linux.svg';
import {ReactComponent as OsMacIcon} from './assets/os-mac.svg';
import {ReactComponent as OsPcIcon} from './assets/os-pc.svg';
import {ReactComponent as OsTabletIcon} from './assets/os-tablet.svg';
import {ReactComponent as OsUnsupportedIcon} from './assets/os-unsupported.svg';
import {ReactComponent as OsWindowsIcon} from './assets/os-windows.svg';
import {ReactComponent as PaperClipIcon} from './assets/paper-clip.svg';
import {ReactComponent as PauseIcon} from './assets/pause.svg';
import {ReactComponent as PermissionIcon} from './assets/permission.svg';
import {ReactComponent as PhoneEndIcon} from './assets/phone-end.svg';
import {ReactComponent as PhoneFilledIcon} from './assets/phone-filled.svg';
import {ReactComponent as PhoneForwardIcon} from './assets/phone-forward.svg';
import {ReactComponent as PhoneHistoryIcon} from './assets/phone-history.svg';
import {ReactComponent as PhonePauseIcon} from './assets/phone-pause.svg';
import {ReactComponent as PhoneIcon} from './assets/phone.svg';
import {ReactComponent as PinIcon} from './assets/pin.svg';
import {ReactComponent as ProtectedFilledIcon} from './assets/protected-filled.svg';
import {ReactComponent as ProtectedIcon} from './assets/protected.svg';
import {ReactComponent as QuestionIcon} from './assets/question.svg';
import {ReactComponent as QueueIcon} from './assets/queue.svg';
import {ReactComponent as RecordDisabledIcon} from './assets/record-disabled.svg';
import {ReactComponent as RecordIcon} from './assets/record.svg';
import {ReactComponent as ReplyIcon} from './assets/reply.svg';
import {ReactComponent as RocketFilledIcon} from './assets/rocket-filled.svg';
import {ReactComponent as RocketIcon} from './assets/rocket.svg';
import {ReactComponent as RotateIcon} from './assets/rotate.svg';
import {ReactComponent as ScreenshotsIcon} from './assets/screenshots.svg';
import {ReactComponent as SendIcon} from './assets/send.svg';
import {ReactComponent as SessionNotes} from './assets/session-notes.svg';
import {ReactComponent as SettingsFilledIcon} from './assets/settings-filled.svg';
import {ReactComponent as SettingsIcon} from './assets/settings.svg';
import {ReactComponent as ShareScreenInIcon} from './assets/share-screen-in.svg';
import {ReactComponent as ShareScreenOffIcon} from './assets/share-screen-off.svg';
import {ReactComponent as ShareScreenOutIcon} from './assets/share-screen-out.svg';
import {ReactComponent as SipIcon} from './assets/sip.svg';
import {ReactComponent as Speaker} from './assets/speaker.svg';
import {ReactComponent as StarIcon} from './assets/star.svg';
import {ReactComponent as SwitchCameraIcon} from './assets/switch-camera.svg';
import {ReactComponent as TableView} from './assets/table-view.svg';
import {ReactComponent as TelegramIcon} from './assets/telegram.svg';
import {ReactComponent as TextChatHistoryIcon} from './assets/text-chat-history.svg';
import {ReactComponent as UnpinIcon} from './assets/unpin.svg';
import {ReactComponent as UserAdd} from './assets/user-add.svg';
import {ReactComponent as UsersIcon} from './assets/users.svg';
import {ReactComponent as VideoCallIcon} from './assets/video-call.svg';
import {ReactComponent as VideoChatIcon} from './assets/video-chat.svg';
import {ReactComponent as VideoOffIcon} from './assets/video-off.svg';
import {ReactComponent as VideoOnIcon} from './assets/video-on.svg';
import {ReactComponent as ViewGridIcon} from './assets/view-grid.svg';
import {ReactComponent as ViewListIcon} from './assets/view-list.svg';
import {ReactComponent as VirtualBackgroundIcon} from './assets/virtual-background.svg';
import {ReactComponent as Visa} from './assets/visa.svg';
import {ReactComponent as Warning} from './assets/warning.svg';
import {ReactComponent as WhatsappIcon} from './assets/whatsapp.svg';
import {ReactComponent as Wifi0} from './assets/wifi-0.svg';
import {ReactComponent as Wifi100} from './assets/wifi-100.svg';
import {ReactComponent as Wifi25} from './assets/wifi-25.svg';
import {ReactComponent as Wifi50} from './assets/wifi-50.svg';
import {ReactComponent as Wifi75} from './assets/wifi-75.svg';

export const ICONS = {
    'add-credit-card': AddCreditCard,
    activities: Activities,
    agent: AgentIcon,
    'agent-participant': AgentParticipantIcon,
    'agent-unavailable': AgentUnavailableIcon,
    'agent-after-hours': AgentAfterHoursIcon,
    'agent-calling': AgentCallingIcon,
    'alert-circle': AlertCircle,
    'alert-triangle': AlertTriangle,
    'american-express': AmericanExpress,
    archive: Archive,
    'arrow-down': ArrowDown,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    assignment: Bookmark,
    'assistant-participant': Eye, // TODO: ICON
    'audio-video': AudioVideoIcon,
    audio: AudioIcon,
    avatar: Chatbot, // TODO: new icon
    'avatar-history': Chatbot, // TODO: new icon
    'background-blur': BackgroundBlurIcon,
    'bar-chart': BarChart,
    'bell-on': BellOnIcon,
    'bell-off': BellOffIcon,
    'book-open': BookOpen,
    'browser-chrome': BrowserChromeIcon,
    'browser-edge': BrowserEdgeIcon,
    'browser-firefox': BrowserFirefoxIcon,
    'browser-ie': BrowserIeIcon,
    'browser-opera': BrowserOperaIcon,
    'browser-safari': BrowserSafariIcon,
    'browser-samsung': BrowserSamsungIcon,
    'browser-unsupported': BrowserUnsupportedIcon,
    calendar: Calendar,
    'calendar-remove': CalendarRemove,
    camera: CameraIcon,
    chat: ChatIcon,
    'chat-gpt': ChatGpt,
    claude: Claude,
    'chat-highlighted-unread': ChatHighlightedUnreadIcon,
    'chat-highlighted': ChatHighlightedIcon,
    'chat-unread': ChatUnreadIcon,
    chat2: Chat2Icon,
    check: Check,
    'check-circle': CheckCircle,
    'check-square': CheckSquare,
    checklist: ChecklistIcon,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    'client-participant': ClientParticipantIcon,
    close: X,
    'co-browsing': CoBrowsingIcon,
    clock: Clock,
    completed: CompletedIcon,
    copy: Copy,
    'corner-up-left': CornerUpLeft,
    'corner-left-up': CornerLeftUp,
    chatbot: Chatbot,
    'create-link': CreateLinkIcon,
    'credit-card': CreditCard,
    'cross-line': CrossLineIcon,
    delete: Trash,
    discover: Discover,
    'device-phone': DevicePhoneIcon,
    'device-sip': DeviceSipIcon,
    duplicate: Duplicate,
    download: Download,
    'download-cloud': DownloadCloud,
    edit: Edit2,
    email: EmailIcon,
    expand: Maximize,
    eye: Eye,
    'eye-off': EyeOff,
    'face-very-dissatisfied': FaceVeryDissatisfied,
    'face-dissatisfied': FaceDissatisfied,
    'face-neutral': FaceNeutral,
    'face-satisfied': FaceSatisfied,
    'face-very-satisfied': FaceVerySatisfied,
    'file-text': FileText,
    filter: Filter,
    folders: Folders,
    'guest-participant': Users, // TODO: new icon
    grid: GridIcon,
    id: IdIcon,
    jcb: Jcb,
    support: HelpCircle,
    hourglass: HourglassIcon,
    info: Info,
    list: List,
    logo: LogoIcon,
    'logo-crossed': LogoCrossedIcon,
    lock: Lock,
    'lock-closed': LockClosedIcon,
    'lock-opened': LockOpenedIcon,
    'log-out': LogOut,
    mail: Mail,
    'map-pin': MapPin,
    mastercard: MasterCard,
    'media-settings': MediaSettings,
    menu: Menu,
    microphone: MicrophoneIcon,
    'microphone-off': MicrophoneOffIcon,
    'microphone-on': MicrophoneOnIcon,
    minus: Minus,
    'minus-circle': MinusCircle,
    'more-horizontal': MoreHorizontal,
    'more-vertical': MoreVertical,
    'multiscreen-on': MultiscreenOnIcon,
    'multiscreen-off': MultiscreenOffIcon,
    'external-link': ExternalLink,
    'os-android': OsAndroidIcon,
    'os-linux': OsLinuxIcon,
    'os-pc': OsPcIcon,
    'os-mac': OsMacIcon,
    'os-tablet': OsTabletIcon,
    'os-unsupported': OsUnsupportedIcon,
    'os-windows': OsWindowsIcon,
    'paper-clip': Paperclip,
    'paper-clip2': PaperClipIcon,
    pause: PauseIcon,
    'pause-circle': PauseCircle,
    permission: PermissionIcon,
    phone: PhoneIcon,
    'phone-call': PhoneCall,
    'phone-end': PhoneEndIcon,
    'phone-forward': PhoneForwardIcon,
    'phone-filled': PhoneFilledIcon,
    'phone-pause': PhonePauseIcon,
    'phone-missed': PhoneMissed,
    'phone-history': PhoneHistoryIcon,
    pin: PinIcon,
    unpin: UnpinIcon,
    play: Play,
    'play-circle': PlayCircle,
    plus: Plus,
    'plus-circle': PlusCircle,
    protected: ProtectedIcon,
    'protected-filled': ProtectedFilledIcon,
    question: QuestionIcon,
    queue: QueueIcon,
    record: RecordIcon,
    'record-disabled': RecordDisabledIcon,
    refresh: RefreshCw,
    reply: ReplyIcon,
    rocket: RocketIcon,
    'rocket-filled': RocketFilledIcon,
    rotate: RotateIcon,
    screenshots: ScreenshotsIcon,
    search: Search,
    send: SendIcon,
    'session-notes': SessionNotes,
    settings: SettingsIcon,
    'settings-filled': SettingsFilledIcon,
    'share-screen-in': ShareScreenInIcon,
    'share-screen-off': ShareScreenOffIcon,
    'share-screen-out': ShareScreenOutIcon,
    shield: Shield,
    shrink: Minimize,
    sip: SipIcon,
    slash: Slash,
    speaker: Speaker,
    star: StarIcon,
    'switch-camera': SwitchCameraIcon,
    'table-view': TableView,
    telegram: TelegramIcon,
    'text-chat-history': TextChatHistoryIcon,
    user: User,
    'user-add': UserAdd,
    users: UsersIcon,
    'user-x': UserX,
    video: Video,
    'video-call': VideoCallIcon,
    'video-chat': VideoChatIcon,
    'video-off': VideoOffIcon,
    'video-on': VideoOnIcon,
    'view-grid': ViewGridIcon,
    'view-list': ViewListIcon,
    visa: Visa,
    'virtual-background': VirtualBackgroundIcon,
    warning: Warning,
    'wifi-0': Wifi0,
    'wifi-25': Wifi25,
    'wifi-50': Wifi50,
    'wifi-75': Wifi75,
    'wifi-100': Wifi100,
    'wifi-off': WifiOff,
    whatsapp: WhatsappIcon,
    'x-circle': XCircle
};
